import React from 'react';
import { Event } from '@material-ui/icons';
import FormConfigFile from '../../config/FormConfigFile';
import { FormFile } from '../../fields/FormFile';
export const FormFilePlugin = {
    icon: React.createElement(Event, null),
    name: 'File upload',
    type: 'File',
    dataTypes: ['jsonb'],
    configurator: FormConfigFile,
    init: (type, _, previousElement) => ({
        type,
        multiple: true,
        title: (previousElement === null || previousElement === void 0 ? void 0 : previousElement.title) || 'Upload a file',
        key: (previousElement === null || previousElement === void 0 ? void 0 : previousElement.key) || 'file'
    }),
    element: FormFile
};
//# sourceMappingURL=FormFilePlugin.js.map